// Suggerimento emoji dalla descrizione della spesa (it/en, substring match,
// prima voce che matcha vince → l'ORDINE conta: le regole specifiche stanno
// sopra quelle generiche, es. "spesa/groceries" prima di "acqua" così
// "Acqua groceries" resta 🛒 mentre "Acqua" diventa 💧).
// Ampliato il 2026-07-21 sulle descrizioni realmente scritte dagli utenti.

const RULES = [
  // ── Viaggio / trasporti ────────────────────────────────────────────────
  // NB: match per sottostringa → dove è sicuro si usa la RADICE (bigliett →
  // biglietto/biglietti), altrimenti si elencano le forme (volo/voli: "vol"
  // matcherebbe "volante", "rivoluzione"…).
  ['✈️', ['volo', 'voli', 'flight', 'aere', 'plane', 'airport', 'ryanair', 'easyjet', 'wizz', 'boarding', 'imbarco', 'low cost']],
  ['🧳', ['bagagl', 'valigi', 'luggage', 'baggage', 'stiva', 'deposito baggage']],
  ['🛂', ['passaport', 'passport', 'visto turistico', 'dogana', 'customs']],
  ['🏨', ['hotel', 'alberg', 'ostell', 'hostel', 'airbnb', 'b&b', 'alloggi', 'booking', 'pensione', 'guesthouse', 'motel', 'resort', 'camera doppia']],
  ['⛺', ['campegg', 'camping', 'tenda', 'glamping', 'piazzola']],
  ['🚆', ['treno', 'treni', 'trenino', 'train', '=italo', 'trenitalia', 'frecc', 'intercity', 'railway', 'regionale', 'binario', 'eurostar']],
  ['🚇', ['metropolitan', 'subway', 'tram', '=tube', 'funicolar', '=metro']],
  ['🚡', ['funivia', 'funivie', 'cabinovia', 'seggiovia', 'cable car']],
  ['🚌', ['=bus', 'autobus', 'pullman', 'flixbus', 'corriera', 'coach', 'navett', 'shuttle', 'trasporto pubblico']],
  ['🚕', ['taxi', 'uber', 'bolt ', 'lyft', 'ncc', '=cab', 'tuk tuk', 'tuktuk', 'risciò']],
  ['🔧', ['meccanic', 'officina', 'gommist', 'tagliando', 'riparazion', 'repair', 'mechanic', 'carrozzeria', 'ricambi', 'batteria auto', 'pneumatic']],
  ['🛡️', ['assicurazion', 'insurance', 'polizza', 'rc auto', 'green card']],
  ['⛽', ['benzin', 'gasolio', 'diesel', 'fuel', 'distributore', 'rifornimento', 'carburant', 'gpl', 'metano', 'petrol', 'gas station']],
  ['🛣️', ['autostrad', 'pedagg', 'toll', 'telepass', 'vignetta', 'highway', 'casello', 'motorway']],
  ['🅿️', ['parchegg', 'parking', 'sosta', 'garage', 'strisce blu']],
  ['🚗', ['noleggio auto', 'rental', 'rent a car', 'macchina', '=auto', '=car', 'autonoleggio', 'carsharing', 'car sharing', 'blablacar', 'passaggio auto']],
  ['🛵', ['scooter', 'motorin', '=moto', 'monopattin', 'motociclett']],
  ['🚲', ['bici', 'bike', 'cycling', 'pedalata']],
  ['⛴️', ['traghett', 'ferry', '=nave', '=navi', 'barca', 'barche', 'boat', 'crocier', 'cruise', 'kayak', 'canoa', 'aliscafo', 'gommone', 'imbarcazion']],

  // ── Cibo e bevande ─────────────────────────────────────────────────────
  ['🍕', ['pizz', 'focacc']],
  ['🍣', ['sushi', 'ramen', '=poke', 'sashimi', 'wok']],
  ['🍔', ['burger', 'hamburger', 'mcdonald', 'mc donald', 'panin', 'sandwich', '=toast']],
  ['🥙', ['gyros', 'kebab', 'pita', 'shawarma', 'burrito', 'taco', 'piadin', '=wrap', 'falafel', 'arancin']],
  ['🍝', ['pasta', 'spaghetti', 'carbonara', 'lasagn', 'risotto']],
  ['🥩', ['carne', '=meat', '=bbq', 'barbecue', 'grigliat', 'steak', 'bistecc', 'churrasco']],
  ['🐟', ['pesce', 'pesci', '=fish', 'frittura', 'seafood']],
  ['🍦', ['gelat', 'ice cream', 'icecream', '=cono', 'sorbetto', 'granita']],
  ['☕', ['caffè', 'caffe', 'coffee', 'colazione', 'breakfast', 'brunch', 'cappuccino', 'espresso', '=tea', 'tisana', 'chai']],
  ['🍷', ['vino', 'wine', 'enoteca', 'cantina', 'prosecco', 'sangria']],
  ['🍰', ['dolce', 'dolci', 'dessert', 'pasticceria', 'pasticcin', 'torta', 'torte', 'cake', 'bombolo', 'ciambell', 'donut', 'croissant', 'cornett', 'crepe', 'waffle', 'baklava', 'biscott']],
  ['🍿', ['snack', 'patatin', 'chips', 'popcorn', 'merend', 'stuzzichin', 'noccioline']],
  ['🍎', ['frutta', 'fruit', 'verdur', 'ortofrutta']],
  ['🧃', ['spremut', 'succo', 'succhi', 'juice', 'smoothie', 'frullat', 'centrifug']],
  ['🍻', ['birr', 'beer', 'drink', 'aperitiv', 'spritz', 'cocktail', 'pub', '=bar', 'sidro', 'cydra', 'happy hour', '=shot']],
  ['🍽️', ['cena', 'cene', 'pranzo', 'pranzi', 'dinner', 'lunch', 'ristorant', 'restaurant', 'trattoria', 'osteria', 'tavola calda', 'mangiat', 'mangiare', 'cibo', 'food', '=menu', 'tavern', 'apericena']],
  ['🛒', ['spesa', 'spese', 'groceries', 'supermercat', 'supermarket', 'lidl', 'conad', 'coop', 'esselunga', 'carrefour', 'market', 'migros', 'aldi', 'penny', 'alimentari', 'minimarket', 'discount']],
  ['💧', ['acqua', 'water', 'bottigli', 'borracc']],

  // ── Casa, utenze, servizi ──────────────────────────────────────────────
  ['🏠', ['affitt', '=rent', '=casa', 'condominio', 'caparra', 'deposito cauzionale']],
  ['💡', ['bollett', 'luce', 'elettric', 'utilities', 'lucett', 'lampad']],
  ['🔥', ['=gas', 'riscaldamento', 'caldaia', 'heating']],
  ['🌐', ['internet', 'wifi', 'fibra', 'router']],
  ['📱', ['telefono', '=sim', 'phone', 'ricarica telefonica', 'vodafone', '=tim', 'iliad', 'roaming']],
  ['📺', ['abbonamento', 'subscription', 'netflix', 'spotify', 'disney', 'prime video', 'canone']],
  ['🧺', ['lavander', 'laundry', 'bucato', 'lavatric', 'lavasecco']],
  ['🧽', ['pulizie', 'detersivo', 'cleaning', 'detergente', 'igiene']],
  ['🪑', ['ikea', 'mobili', 'furniture', 'arredo']],
  ['📦', ['amazon', 'ordine online', 'spedizion', 'shipping', 'consegn', 'delivery', 'corriere', 'pacco', 'pacchi']],

  // ── Persona, salute, tempo libero ──────────────────────────────────────
  ['💊', ['farmac', 'pharmacy', 'medicin', 'antibiotic', 'cerott', 'integrator', 'pastigli']],
  ['🩺', ['dottor', 'medico', 'doctor', 'visita medica', 'dentist', 'analisi', 'tampone', 'fisioterap']],
  ['🏥', ['ospedale', 'hospital', 'pronto soccorso', 'clinica']],
  ['💈', ['barbier', 'parrucchier', 'barber', 'hairdresser', 'taglio capelli', 'haircut']],
  ['💆', ['=spa', 'terme', 'massagg', 'massage', 'sauna', 'hammam']],
  ['🏋️', ['palestra', '=gym', 'fitness', 'crossfit']],
  ['🚬', ['sigarett', 'tabacc', 'cigarett', 'cigs', 'fumo', 'accendin']],
  ['🎟️', ['bigliett', 'ticket', 'ingress', 'muse', 'mostra', 'concert', 'teatro', 'entrata', 'entrance']],
  ['🎬', ['cinema', '=film', 'movie']],
  ['🕺', ['discotec', '=club', '=disco', 'serata']],
  ['🥾', ['escursion', 'tour', 'trekking', 'hiking', 'guida turistica', 'sentier', 'gita', 'gite']],
  ['🏊', ['piscina', '=pool', 'nuoto']],
  ['🏖️', ['spiagg', 'beach', 'lettin', 'ombrellon', 'sun tan', 'lido']],
  ['⛷️', ['=sci', '=ski', 'skipass', 'snowboard']],
  ['⚽', ['partita', 'stadio', 'stadium', '=match', 'calcio']],
  ['🎮', ['videogioco', 'gioco', '=game', 'playstation', '=steam', 'nintendo']],
  ['📚', ['libro', 'libri', '=book', 'librer', 'cancelleria', 'quadern']],
  ['🐶', ['veterinar', '=vet', '=cane', '=cani', 'gatto', 'gatti', 'crocchett', 'animal']],
  ['👕', ['vestit', 'abbigliament', 'clothes', 'shopping', 'scarp', 'shoes', 'magliett', 't-shirt', 'pantalon', 'giacc', 'costume', 'calzin']],
  ['🎁', ['regal', 'gift', 'souvenir']],

  // ── Denaro, banca, tasse ───────────────────────────────────────────────
  ['🏧', ['preliev', 'bancomat', '=atm', 'withdrawal', 'contanti', 'cash']],
  ['🏦', ['banca', 'bank', 'bonifico', 'conto corrente', 'commission', '=fee']],
  ['🤝', ['debit', 'prestit', 'loan', 'rimbors', 'saldo', 'restituz']],
  ['💵', ['mancia', 'mance', '=tip', '=tips']],
  ['🚨', ['multa', 'multe', 'sanzion', 'contravvenz']],
  ['🧾', ['tassa', 'tasse', '=tax', '=bollo', '=iva', 'ricevut', 'scontrin']],
]

// Le keyword con prefisso '=' matchano solo come PAROLA INTERA: servono per
// quelle corte e ambigue ('=bus' non deve matchare "bussola", '=fee' non
// deve matchare "coffee"). Le altre restano substring (radici come 'pizz').
const wordRe = new Map()
function matches(text, kw) {
  if (kw[0] !== '=') return text.includes(kw)
  let re = wordRe.get(kw)
  if (!re) {
    re = new RegExp(`(^|[^\\p{L}])${kw.slice(1)}([^\\p{L}]|$)`, 'u')
    wordRe.set(kw, re)
  }
  return re.test(text)
}

export function suggestEmoji(text) {
  const s = (text ?? '').toLowerCase()
  if (s.length < 3) return null
  for (const [emoji, keywords] of RULES) {
    if (keywords.some(kw => matches(s, kw))) return emoji
  }
  return null
}

// Set curato per la sezione "suggerite" del picker (le più usate in cima)
export const EXPENSE_EMOJIS = [
  '💸', '🍽️', '🛒', '☕', '🍻', '🍕', '🍦', '🍰', '🥙', '🍷',
  '🏨', '✈️', '⛴️', '🚆', '🚌', '🚕', '🚗', '⛽', '🛣️', '🅿️',
  '🎟️', '🎬', '🏖️', '🥾', '🎁', '👕', '💊', '🧺', '🚬', '🧃',
  '💧', '🏠', '💡', '🌐', '📱', '🏧', '🤝', '🧾', '🐶', '📦',
]
